import React, { Component } from "react";
import styled from "styled-components";

import { Search } from "styled-icons/fa-solid/Search";

const InputSearchWraper = styled.div`

    color: ${props => (props.color ? props.color : "white")};
    font-family: sans-serif;
    width: ${props => (props.width ? props.width : "100vw")};
    max-width: ${props => (props.mWidth ? props.mWidth : "100% !important")};
    height: ${props => (props.height ? props.height : "20px")};
    margin: 10px -20px;
    border: 1px solid #f1f1f1;
    border-radius: 50px;
    padding: 15px 10px;
    display: inline-flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-end;
    vertical-align: bottom;
    background: transparent;

  svg {
    line-height: 1em;
  }

  div {
    cursor: text;
    display: inline-flex;
    align-items: center;
    color: ${props => (props.divColor ? props.divColor : "white")}

    input {
      border: none !important;
      outline: none;
      cursor: text;
      font: inherit;
      width: 100%;
      color: ${props => (props.color ? props.color : "white")};
      border: 0;
      margin: 5px 10px !important;
      padding: 10px;
      background: none;
      ::placeholder {
        color: ${props =>
          props.placeholderColor ? props.placeholderColor : "white"};
        font-size: 1rem;
      }
    }
  }
`;

class SearchField extends Component {
  state = {
    value: ""
  };

  handleChange = e => {
    console.log(e);
    this.setState({ value: e.target.value });
  };

  render() {
    const htmlFor = this.props.htmlFor ? this.props.htmlFor : "search";
    const id = this.props.id ? this.props.id : "search";
    const label = this.props.label ? this.props.label : " ";
    const value = this.props.value ? this.props.value : this.state.value;
    const handleChange = this.props.onChange
      ? this.props.onChange
      : this.handleChange;

    return (
      <InputSearchWraper {...this.props}>
        <label htmlFor={htmlFor}>{label}</label>
        <div>
          <Search size="10" title="Search Field" />
          <input
            type={this.props.type ? this.props.type : "text"}
            id={id}
            required={this.props.required ? this.props.required : "required"}
            value={value}
            onChange={e => handleChange(e)}
            placeholder={
              this.props.placeholder ? this.props.placeholder : "Buscar"
            }
          />
        </div>
      </InputSearchWraper>
    );
  }
}

export default SearchField;
